// Dependencies
import moment from 'moment';
import { connect } from 'react-redux';
import ShipmentType from '../../../components/shipment-type/ShipmentType.jsx';
import {
	checkoutChangeSelectedShipmentType,
	checkoutChangeSelectedPaymentType,
} from '../../../redux/checkoutPageReducer';
import CustomerAddressZone from '../../event/customer-address/CustomerAddressZone.jsx';
import TicketAddressZone from '../ticket-address/TicketAddressZone.jsx';
import Checkout from '../../event/Checkout.jsx';

const defaultProps = {
	bookingOffice: {
		activShipmentTypes: [],
		shipmentFees: [],
		shipmentTypeAvailabilityInHours: [],
		activPaymentTypes: [],
		paymentTypeAvailabilityInHours: [],
	},
	shoppingCart: {
		events: [],
		shipmentTypes: {
			shipmentTypes: [],
			disabledShipmentInfo: [],
		},
	},
}

function CheckoutArea(propsIn) {
	const props = {...defaultProps, ...propsIn};
	return (
		<div>
			<ShipmentType
				shipmentTypes={props.shipmentTypes}
				shipmentFees={props.bookingOffice.shipmentFees}
				availabilityInHours={props.bookingOffice.shipmentTypeAvailabilityInHours}
				eventBegin={props.minEventBegin}
				disabledShipmentTypes={props.disabledShipmentTypes}
				shipmentTypeChange={props.shipmentTypeChange}
				selectedShipmentType={props.selectedShipmentType}
			/>
			<CustomerAddressZone customer={props.customer} />
			<TicketAddressZone />
			<Checkout
				eventUUID={props.event.uuid}
				selectedShipmentType={props.selectedShipmentType}
				selectedPaymentType={props.selectedPaymentType}
				subtotal={props.totalSum}
			/>
		</div>
	);
}

const mapStateToProps = (state) => {
	const event = state.event.elements[state.event.selected] || {};
	const shoppingCart = state.shoppingCart.elements[state.merchant.merchantId] || { events: [] };

	const shipmentTypes = state.bookingOffice.activShipmentTypes;
	const disabledShipmentTypes = shoppingCart.shipmentTypes ? shoppingCart.shipmentTypes.disabledShipmentInfo : [];
	const minEventBegin = shoppingCart.events.length < 1 ? '' : shoppingCart.events
		.map(scEvent => scEvent.eventBegin)
		.reduce((a, b) => (moment(a) < moment(b) ? a : b));

	let totalSum = 0;
	if (shoppingCart && shoppingCart.events) {
		shoppingCart.events.map((scEvent) =>
			scEvent.displayTickets.forEach(displayTicket => {
				totalSum += displayTicket.subTotal.money.value;
			}));
	}

	if (state.bookingOffice && state.bookingOffice.shipmentFees[state.checkoutPage.selectedShipmentType]) {
		totalSum += state.bookingOffice.shipmentFees[state.checkoutPage.selectedShipmentType].money.value;
	}

	const selectedShipmentType = state.checkoutPage.selectedShipmentType;

	return {
		minEventBegin,
		shipmentTypes,
		disabledShipmentTypes,
		event,
		bookingOffice: state.bookingOffice,
		customer: state.customer,
		selectedShipmentType,
		selectedPaymentType: state.checkoutPage.selectedPaymentType,
		totalSum,
		showSpinner: !shoppingCart || !state.bookingOffice
			|| state.order.isLoading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	shipmentTypeChange: (event) => {
		dispatch(checkoutChangeSelectedShipmentType(event.target.value));
	},
	paymentTypeChange: (event) => {
		dispatch(checkoutChangeSelectedPaymentType(event.target.value));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CheckoutArea);
